div<template>
  <div>
    <div>
      <span style="font-size: 18px; color: #606266"
        >{{ $l('form_label_expenseCust') || '费用客户' }}：{{
          formData.expenseCustName
        }}</span
      >
    </div>

    <ShipmentPayTable
      class="mt-2"
      :tableData="data"
      :errorKeys="errorKeys"
      @delete="(e) => $emit('delete', e)"
    />
  </div>
</template>

<script>
import ShipmentPayTable from './table.vue'
export default {
  components: { ShipmentPayTable },
  props: {
    data: { type: Array, default: () => [] },
    errorKeys: { type: Array, default: () => [] },
  },
  data() {
    return {
      formData: {
        expenseCustCode: '',
        expenseCustName: '',
      },
    }
  },
  watch: {
    data: {
      handler(e) {
        if (!e || !e.length) return
        const { expenseCustCode = '', expenseCustName = '' } = e[0] || {}
        this.formData.expenseCustCode = expenseCustCode
        this.formData.expenseCustName = expenseCustName
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async getData() {
      return {
        ...this.formData,
        listCode: this.data.map((row) => row.shipmentPayStatementCode),
      }
    },
  },
}
</script>
